export const MUI_ICON_BUTTON_HEIGHT = 40
export const MUI_ICON_BUTTON_WIDTH = 40
